import {formatTimeDurationMs} from '../../utils/timeUtils';
import {
  DURATION_UPPER_LIMIT_MS,
  P50_LATENCY_OBJECTIVE_MS,
  P50_LATENCY_WARNING_MS,
  P50_LATENCY_CRITICAL_MS,
} from '../../utils/constants';

const LatencyBadge = ({ latencyMs }) => {
  let bgClass;
  let description;
  switch (true) {
    case latencyMs === null:
      description = 'No data';
      bgClass = 'secondary';
      break;
    case latencyMs < P50_LATENCY_OBJECTIVE_MS:
      description = 'Great';
      bgClass = 'success';
      break;
    case latencyMs < P50_LATENCY_WARNING_MS:
      description = 'Good';
      bgClass = 'success';
      break;
    case latencyMs < P50_LATENCY_CRITICAL_MS:
      description = 'Fair';
      bgClass = 'warning';
      break;
    default:
      description = 'Poor';
      bgClass = 'danger';
  }
  
  return (
    <div
      className={`d-inline-flex bg-${bgClass}-subtle justify-content-center border border-${bgClass} rounded-4 px-0 py-0`}
      title={description}
      style={{ width: '3.75rem', cursor: 'default' }}
    >
      <span className={`text-${bgClass}-emphasis`} style={{ fontSize: '0.78rem' }}>{formatTimeDurationMs(latencyMs, DURATION_UPPER_LIMIT_MS)}</span>
    </div>
  );
};

export default LatencyBadge;